import Button from '../ui/Button.jsx'

function formatTimer(secs) {
  const h = Math.floor(secs / 3600), m = Math.floor((secs % 3600) / 60), s = secs % 60
  if (h > 0) return `${h}:${String(m).padStart(2,'0')}:${String(s).padStart(2,'0')}`
  return `${m}:${String(s).padStart(2,'0')}`
}

export default function RecordingBar({ clientName, kindLabel, elapsedSecs, paused, onPauseToggle, onStop }) {
  return (
    <div className={`flex items-center justify-between gap-2 border-b border-line px-3 py-3 transition-colors sm:px-6 ${paused ? 'bg-line/30' : 'bg-white'}`}>
      <div className="flex min-w-0 items-center gap-2 sm:gap-3.5">
        {paused ? (
          <span className="flex h-2.5 w-2.5 shrink-0 items-center justify-center">
            <span className="flex h-2.5 gap-[2px]">
              <span className="w-[2px] rounded-[1px] bg-muted" />
              <span className="w-[2px] rounded-[1px] bg-muted" />
            </span>
          </span>
        ) : (
          <span className="relative h-2 w-2 shrink-0 rounded-full bg-terra-500 shadow-[0_0_0_4px_rgba(181,73,31,.18)] animate-pulse-soft" />
        )}
        <div className="min-w-0">
          <div className="truncate text-[13px] font-semibold">{clientName}</div>
          <div className="truncate text-[11px] uppercase tracking-[.4px] text-muted tabular-nums">
            {paused
              ? <>En pause · <span className="text-muted/80">{formatTimer(elapsedSecs)}</span></>
              : <>{kindLabel} · {formatTimer(elapsedSecs)}</>}
          </div>
        </div>
      </div>
      <div className="flex shrink-0 items-center gap-1.5">
        <Button variant="ghost" size="sm" onClick={onPauseToggle} aria-label={paused ? 'Reprendre' : 'Pause'}>
          <span aria-hidden>{paused ? '▶' : '⏸'}</span>
          <span className="hidden sm:inline">{paused ? 'Reprendre' : 'Pause'}</span>
        </Button>
        <Button variant="primary" size="sm" onClick={onStop}>Terminer</Button>
      </div>
    </div>
  )
}
